function storeLastCollection(url, collectionName) {
  const pageData = {
    url: url,
    collectionName: collectionName,
    timestamp: new Date().toISOString()
  };
  
  sessionStorage.setItem('lastCollection', JSON.stringify(pageData));
}

function setBreadcrumbs() {
  const storedData = sessionStorage.getItem('lastCollection');
  
  if (storedData) {
    try {
      const collectionBreadcrumb = document.querySelector('.breadcrumb a.collection-bc');
      const lcd = JSON.parse(storedData);
      collectionBreadcrumb.href = lcd.url;
      collectionBreadcrumb.innerHTML = "<span>" + lcd.collectionName + "</span>";
    } catch (error) {
      console.error('Error parsing previous collection data:', error);
      return null;
    }
  }
}
